import { Component } from '@angular/core';
import { Role } from '../../../shared/role';

@Component({
  selector: 'curr-orientation-video',
  templateUrl: './orientation-video.component.html',
  styleUrls: ['./orientation-video.component.scss']
})
export class OrientationVideoComponent {
  userRole = Role;
}
